import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVippsAgreement } from "../../../../../store/donation/actions";
import { State } from "../../../../../store/state";
import { ToolTip } from "../../../../shared/ToolTip/ToolTip";
import { CustomCheckBox } from "../../../DonorPane/CustomCheckBox";
import { CheckBoxWrapper, HiddenCheckBox } from "../../../Forms.style";
import { DateBoxWrapper, DateText, DateTextWrapper, Wrapper } from "./VippsDatePicker.style";
import { formatDateText, getNextChargeDate, isIrregularChargeDay, showCheckBox } from "./dates";
import { DatePicker } from "../../../../shared/DatePicker/DatePicker";
import { DatePickerInputConfiguration } from "../../../../../../DatePicker/DatePickerInput";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../../../store/donation/types";
const tooltipText = "Vi kan av tekniske grunner ikke melde trekk 1-3 dager i forveien, så første trekkdato utsettes med én måned. Du kan velge en senere dato eller krysse av for også å bli trukket i dag.";
export const VippsDatePicker: React.FC<{
  config: DatePickerInputConfiguration;
}> = t0 => {
  const $ = _c(37);
  const {
    config
  } = t0;
  const dispatch = useDispatch();
  const vippsAgreement = useSelector(_temp);
  const [selectedChargeDay, setSelectedChargeDay] = useState(vippsAgreement.monthlyChargeDay);
  const [initialCharge, setinitialCharge] = useState(true);
  let t1;
  if ($[0] !== initialCharge || $[1] !== selectedChargeDay) {
    t1 = getNextChargeDate(selectedChargeDay, initialCharge);
    $[0] = initialCharge;
    $[1] = selectedChargeDay;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const nextChargeDate = t1;
  let t2;
  if ($[3] !== dispatch || $[4] !== initialCharge || $[5] !== selectedChargeDay || $[6] !== vippsAgreement) {
    t2 = () => {
      dispatch(setVippsAgreement({
        ...vippsAgreement,
        monthlyChargeDay: selectedChargeDay,
        initialCharge
      }));
    };
    $[3] = dispatch;
    $[4] = initialCharge;
    $[5] = selectedChargeDay;
    $[6] = vippsAgreement;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== initialCharge || $[9] !== selectedChargeDay) {
    t3 = [selectedChargeDay, initialCharge];
    $[8] = initialCharge;
    $[9] = selectedChargeDay;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  useEffect(t2, t3);
  const t4 = vippsAgreement.initialCharge && `Første trekk blir i dag, deretter den ${selectedChargeDay === 0 ? "siste" : `${selectedChargeDay}.`} hver måned `;
  const t5 = !vippsAgreement.initialCharge && nextChargeDate && "F\xF8rste trekk blir ";
  let t6;
  if ($[11] !== nextChargeDate || $[12] !== selectedChargeDay || $[13] !== vippsAgreement.initialCharge) {
    t6 = !vippsAgreement.initialCharge && isIrregularChargeDay(selectedChargeDay) ? nextChargeDate && <strong>{`${formatDateText(nextChargeDate)} `}</strong> : !vippsAgreement.initialCharge && nextChargeDate && `${formatDateText(nextChargeDate)} `;
    $[11] = nextChargeDate;
    $[12] = selectedChargeDay;
    $[13] = vippsAgreement.initialCharge;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t5 || $[17] !== t6) {
    t7 = <DateText>{t4}{t5}{t6}</DateText>;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== selectedChargeDay) {
    t8 = isIrregularChargeDay(selectedChargeDay) && <ToolTip text={tooltipText} />;
    $[19] = selectedChargeDay;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div>{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== initialCharge || $[25] !== selectedChargeDay) {
    t10 = showCheckBox(selectedChargeDay) && <CheckBoxWrapper><HiddenCheckBox name="initialCharge" type="checkbox" onChange={() => {
        (document.activeElement as HTMLElement).blur();
        setinitialCharge(!initialCharge);
      }} onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          setinitialCharge(!initialCharge);
          e.preventDefault();
        }
      }} /><CustomCheckBox label={"Trekk meg for denne m\xE5neden ogs\xE5"} checked={initialCharge} /></CheckBoxWrapper>;
    $[24] = initialCharge;
    $[25] = selectedChargeDay;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t9) {
    t11 = <DateTextWrapper>{t9}{t10}</DateTextWrapper>;
    $[27] = t10;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const t12 = vippsAgreement?.monthlyChargeDay;
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = date => {
      if (!showCheckBox(date)) {
        setinitialCharge(false);
      }
      setSelectedChargeDay(date);
    };
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== config || $[32] !== t12) {
    t14 = <DateBoxWrapper><DatePicker selected={t12} onClickOutside={_temp2} onChange={t13} configuration={config} /></DateBoxWrapper>;
    $[31] = config;
    $[32] = t12;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  let t15;
  if ($[34] !== t11 || $[35] !== t14) {
    t15 = <Wrapper>{t11}{t14}</Wrapper>;
    $[34] = t11;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};
function _temp(state) {
  return state.donation.vippsAgreement;
}
function _temp2() {}